import React from 'react';
import PageLayout from './PageLayout';
import ResultTable from './ResultTable';

const ResultPage = () => {
  return (
    <PageLayout>
      <ResultTable />
    </PageLayout>
  );
};

export default ResultPage;
